import { render, staticRenderFns } from "./ForgetPassword_1.vue?vue&type=template&id=5f70ba46&"
import script from "./ForgetPassword_1.vue?vue&type=script&lang=js&"
export * from "./ForgetPassword_1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports